import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConvertWithDecimalPipe } from './convertWithDecimal.pipe';
import { IntialsNamePipe } from './intials-name.pipe';
import { TimeagoPipe } from './timeago.pipe';



@NgModule({
  declarations: [ConvertWithDecimalPipe, IntialsNamePipe, TimeagoPipe],
  imports: [
    CommonModule
  ],
  exports: [
    ConvertWithDecimalPipe,
    IntialsNamePipe,
    TimeagoPipe
  ],
})
export class PipesModule { }
